import { makeObservable, observable, action } from 'mobx'
import axios from 'axios'
import { BaseStore } from './BaseStore'

interface ActivateRequest {
  tmpToken: string
  password: string
  passwordConfirm: string
}

export class ActivateStore extends BaseStore {
  activationSuccess = false

  constructor() {
    super()
    makeObservable(this, {
      activationSuccess: observable,
      activateAccount: action
    })
  }

  async activateAccount(data: ActivateRequest) {
    if (data.password !== data.passwordConfirm) {
      this.setError('パスワードが一致しません')
      this.tryShowToast('パスワードが一致しません', 'error')
      return false
    }

    const result = await this.handleApiCall(async () => {
      const response = await axios.post(
        this.apiPath('v1/auth/activate'),
        {
          tmpToken: data.tmpToken,
          password: data.password,
        }
      )
      return response.data
    })

    if (result) {
      this.activationSuccess = true
      this.tryShowToast('アカウントを有効化しました', 'success')
      return true
    }

    this.tryShowToast('アカウントの有効化に失敗しました', 'error')
    return false
  }
}